module.exports = __webpack_public_path__ + "img/71_M13_feel_the_heat.07679289.jpg";